<script setup lang="ts">
import type { Values } from '@/composables/useValues'

const props = defineProps<{
    data: Values
}>()

/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config, options } = useParams()

/**
 * Use countries.
 */
const { getRegion } = useCountries()

/**
 * List of countries items for dropdown.
 */
const items = computed(() => {
    return options.compareCountries.map(item => ({
        ...item,
        regionName: getRegion(item.value)?.name,
        disabled: !props.data.nonNull.some(({ iso }) => iso === item.value)
    }))
})
</script>

<template>
    <UiSelect
        v-model="config.compareCountries"
        :options="items"
        :label="t('select-countries')"
        :select-all-text="t('select-all-default')"
        :no-selection-text="t('select-all-default')"
        group-key="region"
        group-label="regionName"
        multiple
        direction="top"
        autocomplete
        selectable
        class="flex-shrink-0"
        data-tutorial-step="4"
        :data-tutorial-text="t('tutorial-compare-countries')"
    />
</template>